<template>
  <div>
    <button
      @click.stop="toggle ? endSpeechRecognition() : startSpeechRecognition()"
      class="btn rounded-circle p-0"
      :disabled="disabled"
      :class="{ 'animated infinite speeking': toggle }"
    >
      <img class="speech-img" src="/images/google-voice.png" />
    </button>
  </div>
</template>
<script>
let SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;
let recognition = SpeechRecognition ? new SpeechRecognition() : false;

export default {
  name: "speech-to-text",
  props: {
    lang: {
      type: String,
      default: "en-US",
    },
    accomulative: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  mounted() {
    this.checkCompatibility();
  },
  data() {
    return {
      text: "",
      error: false,
      speaking: false,
      toggle: false,
      runtimeTranscription: "",
      sentences: [],
    };
  },
  methods: {
    checkCompatibility() {
      if (!recognition) {
        this.error =
          "Speech Recognition is not available on this browser. Please use Chrome or Firefox";
      }
    },
    speechStarted() {
      this.speaking = true;
    },
    speechEnded() {
      this.speaking = false;
    },
    recognitionEnd() {
      if (this.runtimeTranscription !== "") {
        this.sentences.push(
          this.capitalizeFirstLetter(this.runtimeTranscription)
        );
        this.$emit("speechupdate", `${this.sentences.join(" ")}`);
      }
      this.runtimeTranscription = "";
      recognition.stop();
      if (this.toggle) {
        recognition.stop();
        // keep it going.
        recognition.start();
      }
    },
    recognitionResult(event) {
      const text = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      this.runtimeTranscription = text;
    },
    endSpeechRecognition() {
      recognition.stop();
      this.toggle = false;
      this.$emit("speechend", {
        sentences: this.sentences,
        text: this.sentences.join(" "),
      });
      if (!this.accomulative) {
        this.sentences = [];
        this.runtimeTranscription = "";
        this.error = "";
        this.text = "";
      }
      this.$emit("speechruning", false);
      this.speaking = false;
    },
    startSpeechRecognition() {
      if (!recognition) {
        this.error =
          "Speech Recognition is not available on this browser. Please use Chrome or Firefox";
        return false;
      }
      this.toggle = true;
      recognition.lang = this.lang;
      recognition.interimResults = true;

      recognition.removeEventListener("speechstart", this.speechStarted);
      recognition.removeEventListener("speechend", this.speechEnded);
      recognition.removeEventListener("end", this.recognitionEnd);
      recognition.removeEventListener("result", this.recognitionResult);

      recognition.addEventListener("speechstart", this.speechStarted);
      recognition.addEventListener("speechend", this.speechEnded);
      recognition.addEventListener("result", this.recognitionResult);
      recognition.addEventListener("end", this.recognitionEnd);
      recognition.start();
      this.$emit("speechruning", true);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
<style scoped lang="scss">
.speech-img {
  width: 23px;
  background-color: white;
  border-radius: 50%;
}

.speeking {
  animation: speekanimate 3s linear infinite;
}
@keyframes speekanimate {
  0% {
    box-shadow: 0 0 0 0 rgba(74, 128, 255, 0.7), 0 0 0 0 rgba(74, 128, 255, 0.7);
  }

  40% {
    box-shadow: 0 0 0 8px rgb(255, 109, 74, 0), 0 0 0 0 rgba(74, 128, 255, 0.7);
  }

  80% {
    box-shadow: 0 0 0 8px rgb(255, 109, 74, 0), 0 0 0 6px rgb(255, 109, 74, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgb(255, 109, 74, 0), 0 0 0 6px rgb(255, 109, 74, 0);
  }
}
</style>
